import { Package, TrendUp, XCircle } from '@phosphor-icons/react';
import { HoverRowActionsDropdown } from '@components/HoverRowActionsDropdown';

type ProductActionsProps = {
  isIgnoredList: boolean;
  onEditQuantity: () => void;
  onIgnore: () => void;
  onActivate: () => void;
};

export function ReplenishmentProductRowActions({
  isIgnoredList,
  onEditQuantity,
  onIgnore,
  onActivate,
}: ProductActionsProps) {
  const items = [
    {
      key: 'edit-qty',
      label: 'Edit Quantity',
      icon: <Package size={18} />,
    },
    isIgnoredList
      ? {
          key: 'activate',
          label: 'Activate Item',
          icon: <TrendUp size={18} />,
        }
      : {
          key: 'ignore',
          label: 'Ignore Item',
          icon: <XCircle size={18} />,
        },
  ];

  const onAction = (key: string) => {
    switch (key) {
      case 'edit-qty':
        onEditQuantity();
        break;
      case 'activate':
        onActivate();
        break;
      case 'ignore':
        onIgnore();
        break;
      default:
        break;
    }
  };

  return <HoverRowActionsDropdown items={items} onAction={onAction} />;
}

type LotActionsProps = {
  onEditQuantity: () => void;
};

export function ReplenishmentLotRowActions({ onEditQuantity }: LotActionsProps) {
  const items = [
    {
      key: 'edit-qty',
      label: 'Edit Quantity',
      icon: <Package size={18} />,
    },
  ];

  return (
    <HoverRowActionsDropdown
      items={items}
      onAction={key => {
        if (key === 'edit-qty') onEditQuantity();
      }}
    />
  );
}
